import React, { useEffect, useMemo, useState } from 'react'
import AdminLoader from '../../../components/common/loader/AdminLoader';
import { useDispatch, useSelector } from 'react-redux';
import { X, Wand2 } from "lucide-react";
import { setExisingClient, setShowWizard } from '../../../store/slices/WizardSlice/WizardSlice';
import { fetchLeads, updateLead } from '../../../store/slices/leadsSlice';
import { fetchGroups } from '../../../store/slices/groupSlice';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { fetchLeadTypes } from '../../../store/slices/leadTypeSlice';
import { fetchStatus } from '../../../store/slices/statusSlice';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { useSnackbar } from 'notistack';
import CommaConvert from '../../../utils/CommaConvert';
import DateConversion from '../../../utils/DateConversion';
import { useCurrencySymbol } from '../../../utils/currencyUtils';
import { fetchLeadByQuotationNumber, resetLeadByQuotation } from '../../../store/slices/fetchLeadByQuotationNumberSlice';
import { useLoggedUser } from '../../../utils/useLoggedUser';

const ExistingClient = ({ setshowWizard }) => {

  const USAComma = CommaConvert();
  const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
  const currency = useCurrencySymbol();
  const loggedUser = useLoggedUser()
  

  const LeadProbablilityAll = useMemo(() => [
    { label: "High" },
    { label: "Medium" },
    { label: "Low" },
  ], []);

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const totalSteps = 4;
  const [step, setStep] = useState(1);
  const [isLoading, SetisLoading] = useState(false);
  const [, setEmpGroups] = useState([]);
  const [clientName, setClientName] = useState("");
  const [filteredEmpLeads, setFilteredEmpLeads] = useState([]);
  const [uniqueClientLeads, setUniqueClientLeads] = useState([]);
  const [existingClientLeads, setExistingClientLeads] = useState([]);
  const [, setLeadTypes] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [Groups, setGroups] = useState([]);
  const [Projects, setProjects] = useState([]);

  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [QuotationNumber, setQuotationNumber] = useState("");

  const [selectedLeadOfClient, setSelectedLeadOfClient] = useState(null);
  const [selectedQuotedValue, setSelectedQuotedValue] = useState(null);
  const [selectedProbability, setSelectedProbability] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedFollowupDate, setSelectedFollowupDate] = useState(null);

  const { group } = useSelector((state) => state.group);
  const { leads } = useSelector((state) => state.leads);
  const { leadTypesRedux } = useSelector((state) => state.leadTypesRedux);
  const { status } = useSelector((state) => state.status);
  const { leadid } = useSelector(
    (state) => state.getLeadByQuotation
  );
  console.log("Groups", Groups)
  console.log("selectedLeadOfClient selectedStatus", selectedStatus)

  console.log("selectedGroup", selectedGroup)
  console.log("selectedClient", selectedClient)

  useEffect(() => {
    dispatch(fetchLeadTypes());
    dispatch(fetchLeads());
    dispatch(fetchGroups());
    dispatch(fetchStatus());
  }, [dispatch]);

  useEffect(() => {
    if (selectedLeadOfClient) {
      const match = statusList.find(
        (s) => s.status === selectedLeadOfClient.Status
      );
      setSelectedStatus(match || null);
    }
  }, [selectedLeadOfClient, statusList]);

  useEffect(() => {
    if (selectedLeadOfClient?.FollowupDate) {
      setSelectedFollowupDate(new Date(selectedLeadOfClient.FollowupDate));
    } else {
      setSelectedFollowupDate(null);
    }
  }, [selectedLeadOfClient]);

  useEffect(() => {
    if (selectedLeadOfClient?.QuotedValue) {
      setSelectedQuotedValue(selectedLeadOfClient.QuotedValue);
    } else {
      setSelectedQuotedValue(null);
    }
  }, [selectedLeadOfClient]);


  useEffect(() => {
    if (selectedLeadOfClient && selectedLeadOfClient?.Status === "Pending") {
      const matchProb = LeadProbablilityAll.find(
        (p) => p.label === selectedLeadOfClient.Probability
      );
      setSelectedProbability(matchProb || null);
    }

  }, [selectedLeadOfClient, LeadProbablilityAll])

  useEffect(() => {
    const empGroup = group.filter((grp) =>
      loggedUser?.EmpGroups?.includes(grp?.newGroupName)
    );
    setEmpGroups(empGroup);

    if (leadTypesRedux?.length > 0) {
      setLeadTypes(leadTypesRedux);
    }

    if (status?.length > 0) {
      setStatusList(status);
    }

  }, [group, loggedUser, leadTypesRedux, status]);


  useEffect(() => {
    const empLeads = leads.filter((lead) =>
      loggedUser?.EmpGroups?.some((grp) =>
        lead?.AssignedGroup?.includes(grp)
      )
    );
    setFilteredEmpLeads(empLeads);

    // const uniqueClient = [...new Set(empLeads.map(item =>
    //   item.ClientName.toLowerCase().trim().replace(/\s+/g, " ")))
    // ].sort((a, b) => a.localeCompare(b));

    // setUniqueClientLeads(uniqueClient);

  }, [group, loggedUser, leads]);

  const autoCompleteStyles = {
    width: "100%",
    "& .MuiInputBase-root": {
      padding: "2px 6px",     // reduce internal padding
      height: 45,             // control height
      borderRadius: 2,        // border radius
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#c4c4c4", // normal border
      },
      "&:hover fieldset": {
        borderColor: "#000",    // hover border
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1976d2", // focus border
      },
    },
    "& .MuiAutocomplete-listbox": {
      padding: 0,             // remove extra vertical padding
    },

    "& .MuiAutocomplete-option": {
      fontSize: "10px",       // reduce dropdown text size
      padding: "4px 4px",     // reduce vertical spacing
      minHeight: "24px",      // set fixed option height (optional)
    },
  };


  const handleNext = () => {
    if (step < totalSteps) setStep(step + 1);
  };

  const handlePrev = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const normalize = (str) =>
    str
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, " "); // collapse multiple spaces


  const handleProjectNameChange = (value) => {
    const normalizedValue = normalize(value);
    setClientName(normalizedValue);
    const clientLeads = leads.filter(
      (lead) => normalize(lead?.ProjectName) === normalizedValue
    );

    console.log("value value", value)
    console.log("value normalizedValue", normalizedValue)
    console.log("value clientLeads", clientLeads)
    console.log("value filteredEmpLeads", filteredEmpLeads)

    setExistingClientLeads([...clientLeads]?.reverse());
  };


  useEffect(() => {
    if (leadid) {
      const selectedLead = leads.filter(lead => lead.id === leadid);
      setExistingClientLeads(selectedLead);
    }

  }, [leads, leadid]);

  useEffect(() => {
    console.log("selectedGroup", selectedGroup)
    console.log("selectedGroup leads", leads)
    const uniqueGroups = [...new Set(leads.map(lead => lead.AssignedGroup?.trim()))];
    console.log("selectedGroup uniqueGroups", uniqueGroups)
    setGroups(uniqueGroups);

  }, [leads, selectedGroup]);

  useEffect(() => {
    console.log("selectedGroupsvsdfrhfgtjtfgjd", selectedGroup)
    console.log("selectedGroupsvsdfrhfgtjtfgjd leads", leads)
    const filteredLeads = leads.filter(lead => lead.AssignedGroup === selectedGroup);

    // Extract unique ClientNames using Set
    const uniqueClientNames = [...new Set(filteredLeads.map(lead => lead.ClientName))];

    console.log("Filtered leads for group:", selectedGroup, filteredLeads);
    console.log("Unique ClientNames:", uniqueClientNames);
    setUniqueClientLeads(uniqueClientNames.sort((a, b) => a.localeCompare(b)));
  }, [leads, selectedGroup]);

  useEffect(() => {
    console.log("selectedGroupsvsdfrhfgtjtfgjd", selectedClient)
    console.log("selectedGroupsvsdfrhfgtjtfgjd leads", leads)

    const filteredLeads = leads.filter(lead => lead.ClientName === selectedClient);
    const uniqueClientNames = [...new Set(filteredLeads.map(lead => lead.ProjectName))];
    console.log("Unique filteredLeads:", filteredLeads);

    console.log("Unique uniqueClientNames:", uniqueClientNames);
    setProjects(uniqueClientNames.sort((a, b) => a.localeCompare(b)));
  }, [leads, selectedClient]);

  const validateLeadUpdate = ({
    selectedStatus,
    selectedFollowupDate,
    selectedProbability,
    selectedLeadOfClient,
    selectedQuotedValue
  }) => {

    const missing = [];

    // Followup Date required if NOT Won/Lost
    if (selectedStatus?.status !== "Won" && selectedStatus?.status !== "Lost") {
      if (!selectedFollowupDate) missing.push("Follow-up Date");
    }

    // Probability required for Pending
    if (selectedStatus?.status === "Pending") {
      if (!selectedProbability) missing.push("Probability");
      else if (!["High", "Medium", "Low"].includes(selectedProbability?.label)) {
        missing.push("Valid Probability");
      }
    }

    // Project Name
    if (!selectedLeadOfClient?.ProjectName) {
      missing.push("Project Name");
    }

    // Quoted Value
    if (!selectedQuotedValue) {
      missing.push("Quoted Value");
    }

    return missing;
  };


  const handleUpdateClient = async (e) => {
    e.preventDefault();

    const missingFields = validateLeadUpdate({
      selectedStatus,
      selectedFollowupDate,
      selectedProbability,
      selectedLeadOfClient,
      selectedQuotedValue
    });

    if (missingFields.length > 0) {
      enqueueSnackbar(`Please fill ${missingFields.join(", ")}`, {
        variant: "error",
      });
      return;
    }

    SetisLoading(true);

    try {
      const updatedLeadData = {
        FollowupDate: selectedFollowupDate ? selectedFollowupDate.toISOString() : null,
        Probability: selectedStatus?.status === "Pending" ? selectedProbability?.label : "",
        QuotedValue: selectedQuotedValue,
        Status: selectedStatus.status,

        ProjectName: selectedLeadOfClient?.ProjectName,
        AssignedGroup: selectedLeadOfClient?.AssignedGroup,
        TypeService: selectedLeadOfClient?.TypeService,
        LeadType: selectedLeadOfClient?.LeadType,
        Source: selectedLeadOfClient?.Source,
        ClientEmail: selectedLeadOfClient?.ClientEmail,
        ClientName: selectedLeadOfClient?.ClientName,

      };

      await dispatch(
        updateLead({ id: selectedLeadOfClient?.id, updatedData: updatedLeadData })
      ).unwrap();

      enqueueSnackbar("Lead Updated Successfully!", { variant: "success" });
      dispatch(setExisingClient(false))
      dispatch(setShowWizard(false))
      dispatch(fetchLeads());
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error?.message || "Something went wrong!", {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
    }
  };

  const handleQuotationSearch = async (value) => {
    console.log("Entered value:", value);
    const quotationNumber = value
    try {
      await dispatch(fetchLeadByQuotationNumber(quotationNumber)).unwrap();
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error?.message || "Something went wrong!", {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-white z-[1500]">
      {isLoading ? (
        <AdminLoader isLoading={isLoading} />
      ) : (<></>)}
      <div className="w-[30%] rounded-2xl shadow-lg bg-gradient-to-b from-blue-500 to-blue-400 text-white p-4 relative font-sans">
        <div>
          <div className="flex">
            <div className="">
              <button
                onClick={() => {
                  dispatch(setExisingClient(false));
                  setshowWizard(true)
                  setExistingClientLeads([])
                  dispatch(resetLeadByQuotation(null))

                }}
                className="absolute top-5 right-4 hover:text-white cursor-pointer">
                <X size={18} />
              </button>
            </div>

            <div className="flex items-center gap-2 mb-4">
              <Wand2 size={20} />
              <h2 className="font-semibold text-lg">Wizard</h2>
            </div>
          </div>

          <div className="w-full bg-white/30 h-2 rounded-full mb-3">
            <div
              className="bg-white h-2 rounded-full transition-all duration-300"
              style={{ width: `${(step / totalSteps) * 100}%` }}
            ></div>
          </div>
          <p className="text-start text-sm mb-4 text-white/90">
            Step {step} of {totalSteps}
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white text-gray-800 p-4 rounded-xl shadow-inner space-y-3"
        >
          {step === 1 && (
            <>
              <div>
                <label className="text-sm font-medium">Search By Quotation No.</label>
                <input
                  name="text"
                  value={QuotationNumber}
                  onChange={(e) => setQuotationNumber(e.target.value)}
                  placeholder="Quotation No."
                  className="w-full border border-gray-300 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleQuotationSearch(e.target.value); // <-- your function
                    }
                  }}
                />

              </div>

              <div className='flex text-sm gap-2 w-full justify-center align-middle items-center '>
                <div style={{ height: "1px", backgroundColor: "black", width: "100%" }}></div>
                or
                <div style={{ height: "1px", backgroundColor: "black", width: "100%" }}></div>

              </div>

              <div>
                <label className="text-sm font-medium">Search Group Name</label>
                <Autocomplete
                  disablePortal
                  options={Groups}       // list of names
                  value={selectedGroup || null}        // selected name
                  onChange={(event, value) => {
                    setSelectedClient();
                    handleProjectNameChange()
                    setExistingClientLeads([])
                    setSelectedGroup(value)
                  }}  // value is the string
                  getOptionLabel={(option) => option || ""}
                  sx={autoCompleteStyles}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Group"
                      variant="outlined"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        sx: { padding: "0 !important" },
                      }}

                    />
                  )}
                />
              </div>

              <div>
                <label className="text-sm font-medium">Search Client Name</label>
                <Autocomplete
                  disablePortal
                  disabled={selectedGroup ? false : true}
                  options={uniqueClientLeads}
                  value={selectedClient || null}
                  onChange={(event, value) => setSelectedClient(value)}
                  getOptionLabel={(option) => option || ""}
                  sx={autoCompleteStyles}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Client"
                      variant="outlined"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        sx: { padding: "0 !important" },
                      }}

                    />
                  )}
                />
              </div>

              <div>
                <label className="text-sm font-medium">Search Project Name</label>
                <Autocomplete
                  disablePortal
                  disabled={selectedClient ? false : true}
                  options={Projects}       // list of names
                  value={clientName || null}        // selected name
                  onChange={(event, value) => handleProjectNameChange(value)}  // value is the string
                  getOptionLabel={(option) => option || ""}
                  sx={autoCompleteStyles}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Client"
                      variant="outlined"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        sx: { padding: "0 !important" },
                      }}

                    />
                  )}
                />
              </div>


              {existingClientLeads.length > 0 && (
                <div className='max-h-[15rem] overflow-auto'>
                  <div className="sticky top-0 flex justify-between font-medium mb-1 w-full">
                    <div className="w-[33.33%] border py-2 flex justify-center align-middle items-center bg-[#3b82f6] text-white">Lead Name</div>
                    <div className="w-[33.33%] border py-2 flex justify-center align-middle items-center bg-[#3b82f6] text-white">Status</div>
                    <div className="w-[33.33%] border py-2 flex justify-center align-middle items-center bg-[#3b82f6] text-white">Action</div>
                  </div>

                  <div className="space-y-1 w-full">
                    {existingClientLeads.length > 0 ? (
                      existingClientLeads.map((lead) => {
                        console.log("selectedLead existingClientLeads", existingClientLeads)

                        return (
                          <div
                            key={lead.id}
                            className="flex h-10 justify-between items-center border border-gray-300 rounded-md  hover:bg-gray-50"
                          >
                            <div className="w-[33.33%] text-[11px] h-full border flex justify-center align-middle items-center text-center break-all whitespace-normal text-wrap py-1">{lead.ProjectName}</div>
                            <div className="w-[33.33%] text-[11px] h-full border flex justify-center align-middle items-center">{lead.Status}</div>
                            <div className="w-[33.33%] text-[11px] h-full border flex justify-center align-middle items-center">
                              <button
                                onClick={() => {
                                  setSelectedLeadOfClient(lead);
                                  setStep(2);        // ← ADD THIS LINE
                                }}
                                className=" px-2 py-[2px] text-[11px] bg-blue-500 text-white rounded hover:bg-blue-600">
                                View
                              </button>
                            </div>
                          </div>

                        )
                      }

                      )
                    ) : (
                      <div className="text-[10px] text-gray-600">No leads found.</div>
                    )}
                  </div>
                </div>
              )}


            </>
          )}

          {step === 2 && (
            <div>
              <h3 className="font-semibold mb-2 -mt-2 text-base">
                Lead Source & Project Details
              </h3>

              <div className="space-y-1">
                <p className="text-sm"><span className="font-medium">Lead Date: </span>
                  {selectedLeadOfClient?.LeadDate
                    ? formatDateByCountry(selectedLeadOfClient?.LeadDate)
                    : ""}
                </p>
                <p className="text-sm"><span className="font-medium">Project Name:</span> {selectedLeadOfClient?.ProjectName || ""}</p>
                <p className="text-sm"><span className="font-medium">Group:</span> {selectedLeadOfClient?.AssignedGroup || ""}</p>
                <p className="text-sm">
                  <span className="font-medium">Type Of Service:</span> {selectedLeadOfClient?.TypeService?.join(", ") || ""}
                </p>
                <p className="text-sm"><span className="font-medium">Quoted Value ({currency}):</span> {USAComma(selectedLeadOfClient?.QuotedValue) || ""}</p>
                <p className="text-sm"><span className="font-medium">Status:</span> {selectedLeadOfClient?.Status || ""}</p>
                {(selectedLeadOfClient?.status === "Pending" || selectedLeadOfClient?.status === "pending") && (
                  <p className="text-sm"><span className="font-medium">Status:</span> {selectedLeadOfClient?.Probability || ""}</p>
                )}
                <p className="text-sm"><span className="font-medium">Lead Type:</span> {selectedLeadOfClient?.LeadType || ""}</p>
                <p className="text-sm"><span className="font-medium">Source:</span> {selectedLeadOfClient?.Source || ""}</p>
                <p className="text-sm"><span className="font-medium">Follow-Up Date: </span>
                  {selectedLeadOfClient?.FollowupDate
                    ? formatDateByCountry(selectedLeadOfClient?.FollowupDate)
                    : ""}
                </p>
              </div>
            </div>

          )}

          {step === 3 && (
            <div>
              <h3 className="font-semibold mb-2 text-base">
                Financials & Lead Metrics
              </h3>
              <div>
                <label className="text-sm font-medium">Quoted Value</label>({currency})
                <input
                  name="text"
                  value={selectedQuotedValue ? USAComma(selectedQuotedValue) : ""}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[^\d.]/g, '');
                    setSelectedQuotedValue(rawValue);
                  }}
                  placeholder="Select Source"
                  className="w-full border border-gray-300 rounded-md px-2 py-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none"
                />
              </div>

              <div>
                <label className="text-sm font-medium">Status</label>
                <Autocomplete
                  disablePortal
                  options={
                    selectedLeadOfClient?.Status?.toLowerCase() === "won recurring"
                      ? statusList.filter(option => option.status === "Won")
                      : statusList
                  }
                  value={selectedStatus}
                  getOptionLabel={(option) => option.status || ""}
                  onChange={(event, value) => setSelectedStatus(value)}
                  sx={autoCompleteStyles}
                  disabled={selectedLeadOfClient?.Status?.toLowerCase() === "won"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={
                        selectedLeadOfClient?.Status?.toLowerCase() === "won"
                          ? "Status locked - Won"
                          : "Select Status"
                      }
                      variant="outlined"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        sx: { fontSize: "15px", padding: "0 !important" },
                      }}
                      InputLabelProps={{
                        sx: { fontSize: "15px" },
                      }}
                    />
                  )}
                />
              </div>
              {selectedStatus?.status === "Pending" && (
                <div>
                  <label className="text-sm font-medium">Probability</label>
                  <Autocomplete
                    disablePortal
                    options={LeadProbablilityAll}
                    value={selectedProbability}
                    onChange={(event, value) => setSelectedProbability(value)}
                    sx={autoCompleteStyles}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Probability"
                        variant="outlined"
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          sx: { fontSize: "15px", padding: "0 !important" },
                        }}
                        InputLabelProps={{
                          sx: { fontSize: "15px" },
                        }}
                      />
                    )}
                  />
                </div>
              )}
            </div>
          )}

          {step === 4 && (
            <div>
              {(
                (
                  selectedStatus?.status === "Pending" ||
                  selectedStatus?.status === "Won Recurring"
                ) ||
                (
                  !selectedStatus?.status &&
                  (selectedLeadOfClient?.Status === "Pending" ||
                    selectedLeadOfClient?.Status === "Won Recurring")
                )
              ) && (
                  <div className="flex flex-col pb-2">
                    <label className="text-sm font-medium">
                      Follow-Up Date
                    </label>
                    <DatePicker
                      selected={selectedFollowupDate}
                      onChange={(date) => setSelectedFollowupDate(date)}
                      placeholderText={getDatePlaceholder()}
                      className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-[12px] focus:ring-2 focus:ring-blue-400 outline-none"
                      dateFormat={getDateFormat()}
                    />
                  </div>
                )}

            </div>
          )}
          <div className="flex justify-between mt-4">
            {/* {step !== 1 && (
              <>
                {step > 1 ? (
                  <button
                    type="button"
                    onClick={handlePrev}
                    className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
                  >
                    Back
                  </button>
                ) : (
                  <button
                    type="button"
                    className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md opacity-50 cursor-not-allowed text-sm"
                    disabled
                  >
                    Back
                  </button>
                )}
              </>
            )}

            {step !== 1 && (
              <>
                {step < totalSteps ? (
                  <button
                    type="button"
                    onClick={handleNext}
                    disabled={!clientName || existingClientLeads.length === 0}
                    className={`px-3 py-1.5 rounded-md text-sm 
                ${!clientName || existingClientLeads.length === 0
                        ? "bg-blue-300 text-white cursor-not-allowed"
                        : "bg-blue-500 text-white hover:bg-blue-600"
                      }`}
                  >
                    {step === 2 && existingClientLeads.length > 0 ? "Edit" : "Next"}
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      handleUpdateClient(e)
                    }}
                    type="submit"
                    className="px-3 py-1.5 bg-green-500 text-white rounded-md hover:bg-green-600 text-sm"
                  >
                    Save Changes
                  </button>
                )}
              </>
            )} */}

            {step !== 1 && (
              <>
                {step > 1 ? (
                  <button
                    type="button"
                    onClick={handlePrev}
                    className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
                  >
                    Back
                  </button>
                ) : (
                  <button
                    type="button"
                    className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md opacity-50 cursor-not-allowed text-sm"
                    disabled
                  >
                    Back
                  </button>
                )}
              </>
            )}

            {/* ---- RIGHT SIDE BUTTON (Next / Save) ---- */}
            {step !== 1 && (
              <>
                {/* ---- SHOW SAVE ON STEP 3 WHEN STATUS IS LOST/WON ---- */}
                {(step === 3 &&
                  (selectedStatus?.status?.toLowerCase() === "lost" ||
                    selectedStatus?.status?.toLowerCase() === "won" ||
                    selectedLeadOfClient?.Status?.toLowerCase() === "lost" ||
                    selectedLeadOfClient?.Status?.toLowerCase() === "won")) ? (

                  <button
                    onClick={(e) => handleUpdateClient(e)}
                    type="submit"
                    className="px-3 py-1.5 bg-green-500 text-white rounded-md hover:bg-green-600 text-sm"
                  >
                    Save Changes
                  </button>

                ) : step < totalSteps ? (

                  <button
                    type="button"
                    onClick={handleNext}
                    // disabled={!clientName || existingClientLeads.length === 0}
                    className={`px-3 py-1.5 rounded-md text-sm  bg-blue-500 text-white hover:bg-blue-600`}
                  >
                    {step === 2 && existingClientLeads.length > 0 ? "Edit" : "Next"}
                  </button>

                ) : (

                  <button
                    onClick={(e) => handleUpdateClient(e)}
                    type="submit"
                    className="px-3 py-1.5 bg-green-500 text-white rounded-md hover:bg-green-600 text-sm"
                  >
                    Save Changes
                  </button>
                )}
              </>
            )}


          </div>
        </form>
      </div>
    </div>
  )
}

export default ExistingClient
